import constants from '@/app-configs/constants'

export default [
  {
    title: 'DEBTIA_USERS',
    icon: 'UserIcon',
    action: constants.action.permissionUserView,
    resource: constants.resource.user,
    route: 'users-list',
  },
]
